import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { appUserMergeApi } from 'services/apiDigitalTicket/appUserMerge';

// Constants
import APP_USER_MERGE_CONST from 'constants/appUserMerge';
import { errorMessagersList } from 'helpers/errorMessagers';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';
import { setOpen } from 'store/ducks/snackbars/actions';
import * as AppUserMergeActions from './actions';

// Types
import { AppUserMergeTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof AppUserMergeActions.listAppUserMergeRequest>): any {
  try {
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(appUserMergeApi.list, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        AppUserMergeActions.listAppUserMergeSuccess({
          appUserMergeList: response.data,
          totalCount: parseInt(response.headers.totalcount, 10),
        }),
      );
      yield put(setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('app user merge - list - error', error);

    yield put(
      setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(AppUserMergeActions.listAppUserMergeFailure());
    yield put(setClose());
  }
}

function* update({
  payload,
}: ReturnType<typeof AppUserMergeActions.updateAppUserMergeRequest>): any {
  try {
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(appUserMergeApi.update, {
      data: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(AppUserMergeActions.updateAppUserMergeSuccess());
      yield put(setClose());
      yield put(
        AppUserMergeActions.listAppUserMergeRequest({
          status: APP_USER_MERGE_CONST.STATUS.PENDING,
          _includes: 'primaryUser,secondaryUser',
        }),
      );
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('app user merge - update - error', error);

    yield put(
      setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(AppUserMergeActions.updateAppUserMergeFailure());
    yield put(setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const appUserMergeSagas = [
  takeLatest(AppUserMergeTypes.LIST_APP_USER_MERGE_REQUEST, list),
  takeLatest(AppUserMergeTypes.UPDATE_APP_USER_MERGE_REQUEST, update),
];
